import {Row} from 'antd';
import React from 'react';

export const ListActions = ({className, leftActions, rightActions, middleActions}: any) => (
  <Row className={className} style={{justifyContent: 'space-between '}}>
    <div>{leftActions}</div>
    {middleActions && <div className="middle-actions">{middleActions}</div>}
    <div>{rightActions}</div>
  </Row>
);
